<mat-dialog-content xmlns="http://www.w3.org/1999/html">
  <h2>
    Change password
  </h2>
  <mat-card-content>
    <div class="dialog-text">
      Please log into <a href="https://www.extranet.weee-forum.org/login">https://www.extranet.weee-forum.org</a> and change your password from your user profile
    </div>
    <div class="align-right">
      <button mat-raised-button mat-dialog-close>Ok</button>
    </div>
  </mat-card-content>
</mat-dialog-content>
